import { datadogLogs, LogsInitConfiguration } from '@datadog/browser-logs';

const baseConfig: Partial<LogsInitConfiguration> = {
  site: 'datadoghq.eu',
  service: 'fulfillment-tools',
  forwardErrorsToLogs: true,
  forwardConsoleLogs: ['error'],
  sessionSampleRate: 100,
  version: __VERSION_HASH__,
};

if (import.meta.env.VITE_APP_ENV === 'production' && process.env.NODE_ENV === 'production') {
  datadogLogs.init({
    ...baseConfig,
    clientToken: 'pub25af68060b0b3b1c4bc58c3016aa404d',
  });
}

if (import.meta.env.VITE_APP_ENV === 'development' && process.env.NODE_ENV === 'production') {
  datadogLogs.init({
    ...baseConfig,
    clientToken: 'pub43268fa16946b59a266159243f0d0822',
  });
}
